import { ComponentsOverrides } from "@mui/material";

const styleOverrides: ComponentsOverrides["MuiTabs"] = {
  indicator: {
    backgroundColor: "#689f38",
  },
  root: {
    flexGrow: 2,
    selected: {
      color: "#6d9c15 !important",
    },
  },
};

const StyledTabs = {
  styleOverrides,
};

export default StyledTabs;
